export const washingProgramsColumns = [
  {
    id: 'numero_programa',
    label: 'Número de Programa',
    type: 'number',
    required: true,
  },
  {
    id: 'nombre',
    label: 'Nombre del Programa',
    type: 'text',
    required: true,
  },
  { 
    id: 'lavanderia', 
    label: 'Centro de Lavado', 
    type: 'asyncSelect', 
    sortable: true, 
    required: true, 
    fetchOptions: async () => {
      try {
        const { fetchLaundries } = await import('@/pages/parametrizacion/laundries/Services/laundries.services');
        const response = await fetchLaundries({ limit: 100, offset: 1, query: { estado: 'Activo' } });
        
        if (response && response.data) {
          return response.data?.map(laundry => ({
            value: { 
              id: laundry._id,
              nombre: laundry.nombre 
            },
            label: laundry.nombre
          }));
        }
        return [];
      } catch (error) {
        console.error('Error cargando centros de lavado:', error);
        return [];
      }
    }
  },
  {
    id: 'nivel_suciedad',
    label: 'Nivel de Suciedad',
    type: 'select',
    required: true,
    options: [
      { value: 'alto', label: 'Alto' },
      { value: 'medio', label: 'Medio' },
      { value: 'bajo', label: 'Bajo' },
    ],
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
  {
    id:'factorCarga',
    label:'Factor de Carga (1/F)',
    type:'number',
    required:true
  },
  {
    id: 'productos',
    label: 'Productos',
    type: 'custom',
    render: (row) => {
      const productos = Array.isArray(row.productos) ? row.productos : [];
      const count = productos.length;
      const totalMl = productos.reduce((sum, p) => sum + (Number(p.cantidadMililitros) || 0), 0);
      return (
        <div className="flex items-center gap-1">
          <span className="text-xs bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full">
            {count} prod
          </span>
          {totalMl > 0 && (
            <span className="text-xs text-gray-500">
              {totalMl}ml
            </span>
          )}
        </div>
      );
    },
  },
  {
    id: 'actions',
    label: 'Acciones',
    type: 'actions',
    actions: [
      {
        key: 'products',
        label: 'Productos',
        icon: 'FlaskConical',
        tooltip: 'Gestionar productos',
        className: 'text-blue-600 hover:text-blue-700',
      },
      {
        key: 'edit',
        label: 'Editar',
        icon: 'Edit',
        tooltip: 'Editar programa',
        className: 'text-green-600 hover:text-green-700',
      },
      {
        key: 'delete',
        label: 'Eliminar',
        icon: 'Trash',
        tooltip: 'Eliminar programa',
        className: 'text-red-600 hover:text-red-700',
      },
    ],
  },
];

export const columnsExcel = {
  numero_programa: 'Número de Programa',
  nombre: 'Nombre del Programa',
  'lavanderia.nombre': 'Centro de Lavado',
  nivel_suciedad: 'Nivel de Suciedad',
  estado: 'Estado',
  createdAt: 'Fecha de Creación',
};
